import { Input, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'inputContactoCerto' })
export class InputContactoCerto implements PipeTransform {
  @Input('tipoContacto') tipoContacto: string = '';

  constructor() {}

  transform(valor: any): any {
    if (valor && this.tipoContacto) {
      return valor === this.tipoContacto;
    }
    return false;
  }
}
